import getSeatStatus from './getSeatStatus';

export default function filterAvailableSeats({
  seatsToReserve,
  bookingData,
  direction,
  seats,
  chosenSeats,
  wagonNumber,
}) {
  try {
    return seatsToReserve.filter((seat) => {
      const status = getSeatStatus({
        bookingData,
        direction,
        seat: seats?.[seat],
        chosenSeats,
        wagonNumber,
      });
      return status === 'available';
    });
  } catch {
    return [];
  }
}
